export default __webpack_public_path__ + "static/maki_prince-527485f87699b4ef9552363aa65bf354.png";